import { render } from "./Collection.vue?vue&type=template&id=39076580&scoped=true"
import script from "./Collection.vue?vue&type=script&lang=js"
export * from "./Collection.vue?vue&type=script&lang=js"

import "./Collection.vue?vue&type=style&index=0&id=39076580&scoped=true&lang=css"
import "./Collection.vue?vue&type=style&index=1&id=39076580&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39076580"]])

export default __exports__